import { parametrizacaoDeclaracaoRoutes } from './features/parametrizacao-declaracao/parametrizacao-declaracao.routes';
import { parametrizacaoRecessoRoutes } from './features/parametrizacao-recesso/parametrizacao-recesso.routes';
import { analisarRecessoRoutes } from './features/analisar-recesso/analisar-recesso.routes';
import { solicitarRecessoRoutes } from './features/solicitar-recesso/solicitar-recesso.routes';
import { Routes } from '@angular/router';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { HomeComponent } from './features/home/home.component';
import { LoginComponent } from './features/login/login.component';
import { CallbackComponent } from './features/callback/callback.component';
import { AuthGuard } from './guard/auth-guard/auth.guard';
import { LoginGuard } from './core/guards/login.guard';
import { confirmacaoVagaRoutes } from './features/confirmacao-vaga/confirmacao-vaga.routes';
import { inscricaoRoutes } from './features/inscricao/inscricao.routes';
import { editaisRoutes } from './features/editais/editais.routes';
import { confirmacaoInteresseVagaRoutes } from './features/confirmacao-interesse-vaga/confirmacao-interesse-vaga.routes';
import { programasRoutes } from './features/programas/programas.routes';
import { documentosRoutes } from './features/documentos/documentos.routes';
import { usuariosRoutes } from './features/usuarios/usuarios.routes';
import { vagasRoutes } from './features/vagas/vagas.routes';
import { perfisRoutes } from './features/perfis/perfis.routes';
import { categoriasRoutes } from './features/categorias/categorias.routes';
import { perfisProfissionaisRoutes } from './features/perfis-profissionais/perfis-profissionais.routes';
import { recursoMunicipioRoutes } from './features/recurso-municipio/recurso-municipio.routes';
import { recursoProfissionalRoutes } from './features/recurso-profissional/recurso-profissional.routes';
import { solicitarRecursoMunicipioRoutes } from './features/solicitar-recurso-municipio/solicitar-recurso-municipio.routes';
import { resultadoInterposicaoRecursoMunicipioRoutes } from './features/resultado-interposicao-recurso-municipio/resultado-interposicao-recurso-municipio.routes';
import { solicitarRecursoProfissionalRoutes } from './features/solicitar-recurso-profissional/solicitar-recurso-profissional.routes';
import { resultadoInterposicaoRecursoProfissionalRoutes } from './features/resultado-interposicao-recurso-profissional/resultado-interposicao-recurso-profissional.routes';
import { parametrizacaoEditaisRoutes } from './features/parametrizacao-editais/parametrizacao-editais.routes';
import { parametrizacaoRanqueamentoRoutes } from './features/parametrizacao-ranqueamento/parametrizacao-ranqueamento.routes';
import { baremaRoutes } from './features/barema/barema.routes';
import { gerenciarBaremaRoutes } from './features/gerenciar-barema/gerenciar-barema.routes';
import { gestaoCicloRoutes } from './features/gestao-ciclo/gestao-ciclo.routes';
import { simulacaoRoutes } from './features/simulacao/simulacao.routes';
import { bancaAcoesAfirmativasRoutes } from './features/banca-acoes-afirmativas/banca-acoes-afirmativas.routes';
import { bancoRoutes } from './features/banco/banco.routes';
import { minhaInscricaoRoutes } from './features/minha-inscricao/minha-inscricao.routes';
import { analiseDocumentalRoutes } from './features/analise-documental/analise-documental.routes';
import { gestaoCandidatosRoutes } from './features/gestao-candidatos/gestao-candidatos.routes';
import { escolhaVagasRoutes } from './features/escolha-vagas/escolha-vagas.routes';
import { profissionalHomolRoutes } from './features/profissional-homol/profissional-homol.routes';
import { periodosHomologacaoRoutes } from './features/periodos-homologacao/periodos-homologacao.routes';
import { gerenciarHomologacaoRoutes } from './features/gerenciar-homologacao/gerenciar-homologacao.routes';
import { relatoriosRoutes } from './features/relatorios/relatorios.routes';
import { gestaoMaavRoutes } from './features/gestao-maav/gestao-maav.routes';
import { painelMaavRoutes } from './features/painel-participacao-maav/painel-maav.routes';
import { rmsRoutes } from './features/rms/rms.routes';
import { rmsLoteRoutes } from './features/rms-lote/rms-lote.routes';
import { relatorioRmsRoutes } from './features/relatorio-rms/relatorio-rms.routes';
import { trilhaFormativaRoutes } from './features/trilha-formativa/trilha-formativa.routes';
import { comunicadosRoutes } from './features/comunicados/comunicados.routes';
import { certificadosExternosRoutes } from './features/certificados-externos/certificados-externos.routes';
import { titulacaoRoutes } from './features/titulacao/titulacao.routes';
import { atividadeProfissionalRoutes } from './features/parametrizacao-atividade-profissional/atividade-profissional.routes';
import { registroAtividadeProfissionalRoutes } from './features/registro-atividade-profissional/registro-atividade-profissional.routes';
import { ajudaCustosRoutes } from './features/ajuda-custos/ajuda-custos.routes';
import { alteracaoPerfilProfissionalRoutes } from './features/alteracao-perfil-profissional/alteracao-perfil-profissional.routes';
import { afastamentoRoutes } from './features/afastamento/afastamento.routes';
import { avaliacaoFenotipicaRoutes } from './features/avaliacao-fenotipica/avaliacao-fenotipica.routes';
import { dependenteRoutes } from './features/dependente/dependente.routes';
import { configurarTiposPagamentosRoutes } from './features/configurar-tipos-pagamentos/configurar-tipos-pagamentos.routes';
import { buscaMedicoIntercambistaRmsRoutes } from './features/busca-medico-intercambista-rms/busca-medico-intercambista-rms.routes';
import { desligamentoProfissionalRoutes } from './features/desligamento-profissional/desligamento-profissional.routes';
import { declaracaoParticipacaoRoutes } from './features/declaracao-participacao/declaracao-participacao.routes';
import { validacaoDeclaracaoRoutes } from './features/validacao-declaracao/validacao-declaracao.routes';
import { analiseDocumentalAcoesAfirmativasRoutes } from './features/analise-documental-acoes-afirmativas/analise-documental-acoes-afirmativas.routes';
import { gerenciarFolhaPagamentoRoutes } from './features/gerenciar-folha-pagamento/gerenciar-folha-pagamento.routes';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'ouvidoria',
    loadComponent: () =>
      import('./features/ouvidoria-login/ouvidoria-login.component').then(
        (m) => m.OuvidoriaLoginComponent,
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'auth/callback',
    component: CallbackComponent,
  },
  {
    path: 'pagamento',
    canActivate: [AuthGuard],
    data: {
      title: 'Pagamento',
      breadcrumb: [{ label: 'Pagamento', url: '/pagamento' }],
    },
    loadComponent: () =>
      import('./features/pagamento/pagamento.component').then(
        (m) => m.PagamentoComponent,
      ),
  },
  ...registroAtividadeProfissionalRoutes,
  ...configurarTiposPagamentosRoutes,
  ...gerenciarFolhaPagamentoRoutes,
  ...inscricaoRoutes,
  ...programasRoutes,
  ...documentosRoutes,
  ...usuariosRoutes,
  ...vagasRoutes,
  ...perfisRoutes,
  ...categoriasRoutes,
  ...perfisProfissionaisRoutes,
  ...recursoMunicipioRoutes,
  ...recursoProfissionalRoutes,
  ...solicitarRecursoMunicipioRoutes,
  ...resultadoInterposicaoRecursoMunicipioRoutes,
  ...solicitarRecursoProfissionalRoutes,
  ...resultadoInterposicaoRecursoProfissionalRoutes,
  ...parametrizacaoEditaisRoutes,
  ...parametrizacaoRanqueamentoRoutes,
  ...baremaRoutes,
  ...confirmacaoVagaRoutes,
  ...confirmacaoInteresseVagaRoutes,
  ...gerenciarBaremaRoutes,
  ...gestaoCicloRoutes,
  ...editaisRoutes,
  ...simulacaoRoutes,
  ...bancaAcoesAfirmativasRoutes,
  ...bancoRoutes,
  ...minhaInscricaoRoutes,
  ...analiseDocumentalRoutes,
  ...gestaoCandidatosRoutes,
  ...escolhaVagasRoutes,
  ...profissionalHomolRoutes,
  ...periodosHomologacaoRoutes,
  ...relatoriosRoutes,
  ...gestaoMaavRoutes,
  ...painelMaavRoutes,
  ...rmsRoutes,
  ...rmsLoteRoutes,
  ...relatorioRmsRoutes,
  ...atividadeProfissionalRoutes,
  ...avaliacaoFenotipicaRoutes,
  ...ajudaCustosRoutes,
  ...alteracaoPerfilProfissionalRoutes,
  ...afastamentoRoutes,
  ...dependenteRoutes,
  ...buscaMedicoIntercambistaRmsRoutes,
  ...desligamentoProfissionalRoutes,
  ...buscaMedicoIntercambistaRmsRoutes,
  ...trilhaFormativaRoutes,
  ...comunicadosRoutes,
  ...certificadosExternosRoutes,
  ...titulacaoRoutes,
  ...validacaoDeclaracaoRoutes,
  ...declaracaoParticipacaoRoutes,
  ...parametrizacaoDeclaracaoRoutes,
  ...parametrizacaoRecessoRoutes,
  ...solicitarRecessoRoutes,
  ...analisarRecessoRoutes,
  ...ajudaCustosRoutes,
  ...gerenciarHomologacaoRoutes,
  ...ajudaCustosRoutes,
  ...analiseDocumentalAcoesAfirmativasRoutes,
  {
    path: '**',
    component: NotFoundComponent,
  },
];

